var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStaff = function SvgStaff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.243 14.574c-4.895 0-8.948 3.977-8.948 8.86 0 .552.434.985.987.985h15.923a.976.976 0 0 0 .987-.984c0-4.884-4.053-8.861-8.949-8.861Z",
    fill: "url(#staff_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.244 6.697c-2.724 0-5 2.206-5 4.923 0 2.718 2.276 4.923 5 4.923s5-2.205 5-4.923c0-2.717-2.276-4.923-5-4.923Z",
    fill: "url(#staff_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.699,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.04 0h-9.87a2.953 2.953 0 0 0-2.961 2.954v4.07c0 1.279.829 2.382 1.974 2.775v3.131c0 .394.237.749.612.906a.944.944 0 0 0 1.066-.216l3.257-3.23.414-.413h5.507c1.639 0 2.961-1.32 2.961-2.954v-4.07A2.953 2.953 0 0 0 33.04 0Z",
    fill: "url(#staff_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.819 22.45v3.938l-2.093 1.97H1.678L0 26.388v-.984a2.953 2.953 0 0 1 2.96-2.954h20.858Z",
    fill: "#E8E2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.819 26.388v7.877H.986A.986.986 0 0 1 0 33.28v-6.892h23.819Z",
    fill: "url(#staff_svg__d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.805 24.42c-4.895 0-8.882 3.977-8.882 8.86 0 .551.434.985.987.985H32.7a.976.976 0 0 0 .987-.985c0-4.883-3.987-8.86-8.883-8.86Z",
    fill: "url(#staff_svg__e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.805 16.543a4.93 4.93 0 0 0-4.935 4.923 4.93 4.93 0 0 0 4.935 4.922 4.93 4.93 0 0 0 4.935-4.922 4.93 4.93 0 0 0-4.935-4.923Z",
    fill: "url(#staff_svg__f)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "staff_svg__a",
    x1: -1.688,
    y1: 19.878,
    x2: 4.152,
    y2: 33.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBA1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4214BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "staff_svg__b",
    x1: 10.864,
    y1: 19.448,
    x2: 20.813,
    y2: 13.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB9BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "staff_svg__c",
    x1: 16.646,
    y1: 8.25,
    x2: 28.722,
    y2: 21.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDA9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#642DD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "staff_svg__d",
    x1: -8.845,
    y1: 30.04,
    x2: -4.333,
    y2: 43.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#642DD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "staff_svg__e",
    x1: 10.976,
    y1: 29.724,
    x2: 16.846,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBA1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "staff_svg__f",
    x1: 23.443,
    y1: 29.293,
    x2: 33.326,
    y2: 23.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB9BFF"
  })))));
};
export { SvgStaff as ReactComponent };
export default "data:image/svg+xml;base64,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";